export type SensorStatus = 'online' | 'warning' | 'offline';

export function getSensorStatus(lastUpdated: Date | null): SensorStatus {
  if (!lastUpdated) return 'offline';
  const age = Date.now() - lastUpdated.getTime();
  if (age > 10 * 60 * 1000) return 'offline';
  if (age > 5 * 60 * 1000) return 'warning';
  return 'online';
}
